/*
 * File: d:\projects\AutoFiFront\src\Content\AboutUs\AboutUsHolder.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 15th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 6th November 2023 11:02:25
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect } from 'react';
import styles from 'Content/AboutUs/AboutUsHolder.module.css';
import translator from 'MultiLanguage/TranslationWrapper';
import EngagementAboutUs from 'Content/AboutUs/Engagements/EngagementAboutUs';
import Knowledge from 'Content/SVG/EngagementSVG/Knowledge';
import Hands from 'Content/SVG/EngagementSVG/Hands';
import Transparency from 'Content/SVG/EngagementSVG/Transparency';
import Serenity from 'Content/SVG/EngagementSVG/Serenity';
import BuyBack from 'Content/SVG/EngagementSVG/BuyBack';
import Values from 'Content/AboutUs/Values/Values';
import Passion from 'Content/SVG/ValuesSVG/Passion';
import Trust from 'Content/SVG/ValuesSVG/Trust';
import Proximity from 'Content/SVG/ValuesSVG/Proximity';
import Respect from 'Content/SVG/ValuesSVG/Respect';
// import { useLoaderData } from 'react-router-dom';

type aboutUsHolderProps = {
    anchor?: string
};

function AboutUsHolder (props: aboutUsHolderProps){
    // const textsLoaded: {Key: string, LanguageID:number, Text: string, id: number}[] = useLoaderData() as {Key: string, LanguageID:number, Text: string, id: number}[];

    const knowledge = ["aboutUs.ourEngagementsKnowledgeText1","aboutUs.ourEngagementsKnowledgeText2","aboutUs.ourEngagementsKnowledgeText3","aboutUs.ourEngagementsKnowledgeText4"];
    const relation = ["aboutUs.ourEngagementsRelationText1","aboutUs.ourEngagementsRelationText2","aboutUs.ourEngagementsRelationText3","aboutUs.ourEngagementsRelationText4"];
    const transparency = ["aboutUs.ourEngagementsTransparencyText1","aboutUs.ourEngagementsTransparencyText2"];
    const serenity = ["aboutUs.ourEngagementsSerenityText1","aboutUs.ourEngagementsSerenityText2"];
    const buyback = ["aboutUs.ourEngagementsBuyBackText1","aboutUs.ourEngagementsBuyBackText2"];
    const ourStory = ["aboutUs.ourStoryText1","aboutUs.ourStoryText2","aboutUs.ourStoryText3","aboutUs.ourStoryText4"];
    const values = [
        {
            title:"passion",
            icon:<Passion fill='var(--theme-color)' />
        },
        {
            title:"respect",
            icon:<Respect fill='var(--theme-color)' />
        },
        {
            title:"proximity",
            icon:<Proximity fill='var(--theme-color)' />
        },
        {
            title:"trust",
            icon:<Trust fill='var(--theme-color)' />
        },
    ];

    return (
        <React.Fragment>
            <div id='story' className={`${styles.aboutUsHolder}`}>
                <h1 className={`${styles.titleAboutUs}`}> <span className={`${styles.spanColor}`}>{translator.decode("aboutUs.whoWeArePart1")}</span>{translator.decode("aboutUs.whoWeArePart2")}</h1>
                <div className={`${styles.ourStory}`}>
                    <h2 className={`${styles.subTitleAboutUs}`}>{translator.decode("aboutUs.ourStory")}</h2>
                    <EngagementAboutUs text={ourStory} />
                </div>
                <div id='engagement' className={`${styles.split}`}>
                    <div className={`${styles.leftSide}`}>
                        <img className={`${styles.illustration}`} src="./7.png" alt="Cars parked" />
                        <img className={`${styles.illustration}`} src="./5.png" alt="Hand shake" />
                    </div>
                    <div className={`${styles.rightSide}`}>
                        <h2 className={`${styles.engagementTitle}`}>{translator.decode("aboutUs.ourEngagements")}</h2>
                        <EngagementAboutUs title={"aboutUs.ourEngagementsKnowledge"} text={knowledge} icon={<Knowledge width="3rem" fill='var(--theme-color)'/>} />
                        <EngagementAboutUs title={"aboutUs.ourEngagementsRelation"} text={relation} icon={<Hands width="3rem" fill='var(--theme-color)'/>} />
                    </div>
                </div>
                <div className={`${styles.doubleBlock}`}>
                    <EngagementAboutUs title={"aboutUs.ourEngagementsTransparency"} text={transparency} icon={<Transparency width="3rem" fill='var(--theme-color)'/>} />
                    <EngagementAboutUs title={"aboutUs.ourEngagementsSerenity"} text={serenity} icon={<Serenity width="3rem" fill='var(--theme-color)'/>} />
                </div>
                <div className={`${styles.doubleBlock}`}>
                    <EngagementAboutUs title={"aboutUs.ourEngagementsBuyBack"} text={buyback} icon={<BuyBack width="3rem" fill='var(--theme-color)'/>} />
                    <img className={`${styles.illustration}`} src="./2.png" alt="Man calculating" />
                </div>
                <div id='values' className={`${styles.valuesBlock}`}>
                    <h2 className={`${styles.valuesTitle}`}>{translator.decode("aboutUs.ourValues")}</h2>
                    <div className={`${styles.values}`}>
                        {
                            values.map((item,index)=>{return <Values key={item.title+index} text={item.title} icon={item.icon} />})
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default AboutUsHolder;
